<script>
    export let size = "50px";
    export let color = "#ccc";
</script>

<div
    class="gw-spinner"
    style={`--gw-spinner-size: ${size}; --gw-spinner-color: ${color}`}
>
    <svg class="gw-spinner__inner" viewBox="0 0 50 50">
        <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
        />
    </svg>
</div>

<style lang="postcss">
    .gw-spinner__inner {
        animation: rotate 2s linear infinite;
        width: var(--gw-spinner-size);
        height: var(--gw-spinner-size);

        & .path {
            stroke: var(--gw-spinner-color);
            stroke-linecap: round;
            animation: dash 1.5s ease-in-out infinite;
        }
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
</style>
